<script setup>
import Section from "../internal/Section.vue";
import EditableField from "../fields/EditableField.vue";
import ReadonlyField from "../fields/ReadonlyField.vue";

defineProps({
  data: { type: Object, required: true },
  editMode: { type: Boolean, default: false },
  isOwn: { type: Boolean, default: false },
});

const emit = defineEmits(["update"]);

function setField(key, value) {
  emit("update", key, value);
}
</script>

<template>
  <Section
    icon="sli-education"
    :title="$t('Образование')"
    :sub="$t('Учебное заведение и диплом')"
  >
    <div class="grid grid-cols-2 gap-x-5 gap-y-3.5 max-sm:grid-cols-1">
      <template v-if="editMode">
        <EditableField
          :label="$t('Наименование учебного заведения')"
          full
          :model-value="data.education_institution"
          @update:model-value="setField('education_institution', $event)"
        />
        <EditableField
          :label="$t('Специальность по диплому')"
          :model-value="data.education_specialty"
          @update:model-value="setField('education_specialty', $event)"
        />
        <EditableField
          :label="$t('Номер диплома')"
          :model-value="data.education_diploma_number"
          @update:model-value="setField('education_diploma_number', $event)"
        />
        <EditableField
          :label="$t('Дата окончания')"
          type="date"
          :model-value="data.education_graduation_date"
          @update:model-value="setField('education_graduation_date', $event)"
        />
        <EditableField
          :label="$t('Дата выдачи диплома')"
          type="date"
          :model-value="data.education_diploma_issue_date"
          @update:model-value="setField('education_diploma_issue_date', $event)"
        />
      </template>
      <template v-else>
        <ReadonlyField
          :label="$t('Наименование учебного заведения')"
          full
          :value="data.education_institution"
        />
        <ReadonlyField
          :label="$t('Специальность по диплому')"
          :value="data.education_specialty"
        />
        <ReadonlyField
          :label="$t('Номер диплома')"
          :value="data.education_diploma_number"
        />
        <ReadonlyField
          :label="$t('Дата окончания')"
          :value="data.education_graduation_date"
          type="date"
          size="sm"
        />
        <ReadonlyField
          :label="$t('Дата выдачи диплома')"
          :value="data.education_diploma_issue_date"
          type="date"
          size="sm"
        />
      </template>
    </div>
  </Section>
</template>
